import { OrganisationPublicContent } from 'generated/graphql';
import { create } from 'zustand';

type ConsultantWebshopType = Partial<OrganisationPublicContent> & {
    fullName: string;
};

type ConsultantWebshopStoreType = ConsultantWebshopType & {
    setConsultantWebshopState: (consultantPublicInformation: ConsultantWebshopType) => void;
};

const useConsultantWebshop = create<ConsultantWebshopStoreType>((set) => ({
    fullName: '',
    id: 0,
    email: '',
    facebook_url: '',
    favourite_quote_id: 0,
    first_name: '',
    full_personal_webshop_url: '',
    last_name: '',
    market: '',
    middle_name: '',
    mobile: '',
    personal_webshop_url: '',
    presentation: '',
    profile_url: '',
    title_name_long: '',
    title_name_short: '',
    setConsultantWebshopState: (consultantWebshopInformation) => set({ ...consultantWebshopInformation }),
}));

export default useConsultantWebshop;
